/**
 * PivotProof wordmark as plain HTML text in the site display font.
 *
 * Previously an inline SVG <text> locked with textLength in Space Grotesk —
 * a font the site never loads. On iOS/Android the fallback face rendered
 * wider than the viewBox and the mark was clipped. HTML text can't clip,
 * inherits currentColor, and uses the already-loaded Cabinet Grotesk.
 */
export default function Wordmark({ className = "", height = 24, title = "PivotProof" }) {
  return (
    <span
      role="img"
      aria-label={title}
      className={`font-display font-black tracking-tighter leading-none whitespace-nowrap select-none ${className}`}
      style={{ fontSize: height, lineHeight: 1, display: "inline-block" }}
    >
      <span className="text-white">PIVOT</span>
      <span className="text-[#E5FE40]">PROOF.</span>
    </span>
  );
}
